<template>
  <div class="home">
    <h1 class="sr-only">{{ $t('about.title') }}</h1>
    <HomeHero />
    <HomeNews v-if="!isSmallScreen" />
    <HomeComparison />
    <HomeProducts />
    <HomeSEO />
    <HomeTour />
  </div>
</template>

<script>
import CommonMixin from '@/mixins/Common';
import HomeComparison from '@/components/home/HomeComparison.vue';
import HomeHero from '@/components/home/HomeHero.vue';
import HomeNews from '@/components/home/HomeNews.vue';
import HomeProducts from '@/components/home/HomeProducts.vue';
import HomeSEO from '@/components/home/HomeSEO.vue';
import HomeTour from '@/components/home/HomeTour.vue';

export default {
  name: 'PageHome',

  mixins: [CommonMixin],

  components: {
    HomeComparison,
    HomeHero,
    HomeNews,
    HomeProducts,
    HomeSEO,
    HomeTour,
  },

  computed: {
    metaData() {
      return {
        siteName: process.env.VUE_APP_SITENAME,
        title: `${this.$t('about.title')} - ${process.env.VUE_APP_SITENAME}`,
        description: this.$t('about.description'),
        image: 'https://pilihlaptop.com/img/pilihlaptop-logo-min.png',
      };
    },
  },

  metaInfo() {
    return {
      title: this.$t('about.title'),
      meta: [
        { name: 'description', content: this.metaData.description },
        { name: 'robots', content: 'index,follow' },

        { property: 'og:title', content: this.metaData.title },
        { property: 'og:site_name', content: this.metaData.siteName },
        { property: 'og:description', content: this.metaData.description },
        { property: 'og:image', content: this.metaData.image },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:title', content: this.metaData.title },
        { name: 'twitter:description', content: this.metaData.description },
        { name: 'twitter:image', content: this.metaData.image },
        { name: 'twitter:url', content: 'https://twitter.com/PilihLaptop' },
      ],
      link: [
        { rel: 'canonical', href: 'https://www.pilihlaptop.com' },
      ],
    };
  },
};
</script>
